import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ActiveAddressInAddressSelectorList from './ActiveAddressInAddressSelectorList'

import {AddressShape} from './propTypes'
import { TranslationUtility } from "../../../util/translationUtility";

const mapStateToProps = (state, ownProps) => {
  return {
    translationUtility: new TranslationUtility(state.constants.localizationItems),
    ...ownProps
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {

  const confirmDelete = () => {
    if (typeof window.confirm !== 'undefined')
      return window.confirm("Are you sure you want to delete this address?");
    else
      return false;
  }

  return {
    onSelected: id => {
      ownProps.onSelected(id);
      dispatch(ownProps.selectAddressActionCreator({ addressId: id }));
    },
    onRadioSelected: id => {
      dispatch(ownProps.selectAddressActionCreator({ addressId: id }));
      ownProps.onRadioSelected(id);
    },
    onDelete: id => {
      if (confirmDelete()) {
        ownProps.onDeleted(id);
        dispatch(ownProps.deleteAddressActionCreator({addressId: id}));
      }
    }
  };
}

const AddressSelectorListActiveAddressContainer = connect(mapStateToProps, mapDispatchToProps)(ActiveAddressInAddressSelectorList)

AddressSelectorListActiveAddressContainer.propTypes = {
  address: PropTypes.shape(AddressShape).isRequired,
  deleteAddressActionCreator: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onBeginEdit: PropTypes.func.isRequired,
  onDeleted: PropTypes.func.isRequired,
  onRadioSelected: PropTypes.func.isRequired,
  onSelected: PropTypes.func.isRequired,
  selectAddressActionCreator: PropTypes.func.isRequired,
  selectAddressMessage: PropTypes.string.isRequired
}

export default AddressSelectorListActiveAddressContainer


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Address/ActiveAddressInAddressSelectorListContainer.js